import React, { useRef, useState } from 'react';
import { Carousel, Col, Row, Image, Button, Dropdown, Modal, message, Typography, Spin, } from 'antd';
import { LeftOutlined, RightOutlined, DownloadOutlined, EyeOutlined, } from '@ant-design/icons';
import { fileZipService } from '../../../../services';

const { Text } = Typography;

const CustomArrow = {
    position: "absolute",
    top: "45%",
    color: "black",
    backgroundColor: "#F2F8FB", // Corrected background syntax
    border: "none",
    padding: "5px",
    borderRadius: "100%", // Corrected the border-radius syntax
    cursor: "pointer",
};

export const Gallery = ({ images = [], chassis, loading }) => {
    const carouselRef = useRef(null);
    const modalCarouselRef = useRef(null);
    const thumbnailRefs = useRef([]);
    const [modalIndex, setModalIndex] = useState(0);
    const [activeIndex, setActiveIndex] = useState(0);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);

    const handleDownload = async (type, index = 0) => {
        setDownloadLoading(true);
        let response;

        if (type === 'single') {
            response = await fileZipService.download(chassis, [images[index].filename]);
        } else {
            const imagesPath = images.map((i) => i.filename);
            response = await fileZipService.download(chassis, imagesPath);
        }

        setDownloadLoading(false);
        if (response?.success ?? false) {
            message.success(response.message);
        } else {
            message.error(response?.message ?? 'Something went wrong');
        }
    };

    const downloadMenu = (index) => ({
        items: [
            {
                key: '1',
                label: 'Download This Image',
                onClick: () => handleDownload('single', index),
            },
            {
                key: '2',
                label: 'Download All Images',
                onClick: () => handleDownload('all'),
            },
        ],
    });

    const imageComponet = (
        <div
            style={{
                paddingTop: 50,
                border: '1px solid #ccc',
                backgroundColor: '#f5f5f5',
                borderRadius: 8,
                position: 'relative',
                textAlign: 'center',
                minheight: 500, // or whatever you prefer
            }}
        >
            <Carousel
                ref={carouselRef}
                afterChange={(index) => {
                    setActiveIndex(index);
                    thumbnailRefs.current[index]?.scrollIntoView({
                        behavior: 'smooth',
                        inline: 'center',
                        block: 'nearest',
                    });
                }}
                dots={false}
            >
                {images.map((image, index) => (
                    <div key={index} style={{ position: 'relative' }}>
                        <Image
                            src={image.filename}
                            alt="Main"
                            style={{
                                borderRadius: 8,
                                objectFit: 'cover',
                                width: '99%',
                                height: 380, // Increase this
                                margin: 'auto',
                            }}
                            preview={false}
                            onClick={() => setModalVisible(true)}

                        />
                    </div>
                ))}
            </Carousel>

            {/* Custom Overlay Buttons */}
            <div style={{ position: 'absolute', height: 22, top: 15, paddingTop: 12, left: 0, width: '100%', borderBottom: "1px solid #ccc" }}>
                <p style={{
                    position: 'absolute',
                    top: '3%',
                    left: '2%',
                }}>Vehicle images</p>

                <div
                    style={{
                        position: 'absolute',
                        top: '20%',
                        left: '86%',
                        transform: 'translate(-50%, -50%)',
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 10,
                        zIndex: 10, // Ensure buttons are on top of the image
                    }}
                >

                    <Button
                        size='small'
                        onClick={() => setModalVisible(true)}
                        style={{
                            color: 'black',
                            borderRadius: '10px',
                            padding: '6px',
                            backgroundColor: "#EEF2F6",
                            fontSize: 10,
                            // border:'none'
                        }}
                        className='opacity-85 text-xs'
                    >
                        See All {images.length} {" "} Images
                    </Button>

                    <Dropdown menu={downloadMenu(activeIndex)} placement="bottomCenter">
                        <Button
                            size='small'
                            icon={<DownloadOutlined style={{ fontWeight: "bolder", fontSize: "18px" }} />}
                            loading={downloadLoading}
                            style={{
                                color: 'black',
                                borderRadius: '4px',
                                background: "#EEF2F6",
                                padding: '1px',
                                // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                            }}>
                        </Button>
                    </Dropdown>
                </div>
            </div>

            {/* Arrows */}
            {images.length === 1 ? null :
                (
                    <>
                        <button
                            // className="custom-arrow left"
                            style={{ ...CustomArrow, left: "25px", }}
                            onClick={(e) => {
                                e.preventDefault();
                                carouselRef.current?.prev();
                            }}
                        >
                            <LeftOutlined style={{ fontSize: "18px" }} />
                        </button>
                        <button
                            style={{ ...CustomArrow, right: "25px", }}
                            onClick={(e) => {
                                e.preventDefault();
                                carouselRef.current?.next();
                            }}
                        >
                            <RightOutlined style={{ fontSize: "18px" }} />
                        </button>
                    </>
                )}
            {/* Thumbnail Strip - Single Line */}
            <div
                style={{
                    marginTop: 16,
                    overflowX: 'auto',
                    whiteSpace: 'nowrap',
                    paddingBottom: 8,
                    overflowX: 'hidden',
                }}
            >
                {images.map((img, index) => (
                    <div
                        key={index}
                        ref={(el) => (thumbnailRefs.current[index] = el)}
                        onClick={() => {
                            carouselRef.current.goTo(index);
                            setActiveIndex(index);
                        }}
                        style={{
                            display: 'inline-block',
                            border: activeIndex === index ? '2px solid #B63C3C' : '1px solid #ccc',
                            borderRadius: 4,
                            padding: 2,
                            cursor: 'pointer',
                            marginRight: 8,
                        }}
                    >
                        <Image
                            src={img.filename}
                            width={60}
                            height={60}
                            style={{ objectFit: 'cover', borderRadius: 4 }}
                            preview={false}
                        />
                    </div>
                ))}
            </div>
        </div>
    )

    const modalComponent = (
        <Modal
            open={modalVisible}
            onCancel={() => setModalVisible(false)}
            footer={null}
            width="55%"
            centered={true} // Disable vertical centering
            style={{ top: 15 }}
            styles={{
                padding: "0px",
                body: {
                    padding: "0px",
                    height: '600px',
                    overflowY: 'hidden',
                },
            }}
        >
            <Row justify="start">
                <Dropdown menu={downloadMenu(modalIndex)} placement="bottomRight">
                    <Button icon={<DownloadOutlined />} loading={downloadLoading}>
                        Download
                    </Button>
                </Dropdown>
            </Row>

            <Carousel
                ref={modalCarouselRef}
                dots={false}
                afterChange={(index) => {
                    setModalIndex(index);
                    thumbnailRefs.current[index]?.scrollIntoView({
                        behavior: 'smooth',
                        inline: 'center',
                        block: 'nearest',
                    });
                }}
                style={{ textAlign: 'center', marginTop: 10 }}

            >
                {images.map((image, index) => (
                    <div key={index} style={{ textAlign: 'center', position: 'relative', width: "100%" }}>
                        <Image
                            src={image.filename}
                            style={{ height: 400, Width: '100%', borderRadius: 6 }}
                            preview={true}
                        />
                    </div>
                ))}
            </Carousel>
            <Text
                style={{
                    position: 'absolute',
                    top: 70,
                    right: 2,
                    backgroundColor: "white",
                    transform: 'translateX(-50%)',
                    zIndex: 10,
                    color: 'black',
                    padding: '4px 12px',
                    borderRadius: 4,
                    fontSize: 14,
                }}
            >
                {modalIndex + 1} to {images.length}
            </Text>
            <button
                style={{
                    position: 'absolute',
                    left: 8,
                    bottom: 55,
                    transform: 'translateY(-50%)',
                    width: 16,
                    height: 16,
                    borderRadius: '50%',
                    backgroundColor: '#B83D3D',
                    border: '1px solid #ccc',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10,
                    cursor: 'pointer',
                    color: "white"
                }}
                onClick={(e) => {
                    e.preventDefault();
                    modalCarouselRef.current?.prev();
                }}
            >
                <LeftOutlined style={{ fontSize: 8 }} />
            </button>

            <button
                style={{
                    position: 'absolute',
                    right: 8,
                    bottom: 55,
                    transform: 'translateY(-50%)',
                    width: 16,
                    height: 16,
                    borderRadius: '50%',
                    backgroundColor: '#B83D3D',
                    border: '1px solid #ccc',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10,
                    cursor: 'pointer',
                    color: "white"

                }}
                onClick={(e) => {
                    e.preventDefault();
                    modalCarouselRef.current?.next();
                }}
            >
                <RightOutlined style={{ fontSize: 8 }} />
            </button>

            {/* Modal Thumbnails */}
            <div
                style={{
                    overflowX: 'hidden',
                    whiteSpace: 'nowrap',
                    paddingBottom: 8,
                }}
            >
                {images.map((img, index) => (
                    <div
                        key={index}
                        ref={(el) => (thumbnailRefs.current[index] = el)}
                        onClick={() => {
                            modalCarouselRef.current.goTo(index);
                            setModalIndex(index);
                        }}
                        style={{
                            display: 'inline-block',
                            border: modalIndex === index ? '2px solid #B63C3C' : '1px solid #ccc',
                            borderRadius: 4,
                            padding: 2,
                            cursor: 'pointer',
                            marginRight: 8,
                        }}
                    >
                        <Image
                            src={img.filename}
                            width={60}
                            height={60}
                            style={{ objectFit: 'cover', borderRadius: 4 }}
                            preview={false}
                        />
                    </div>
                ))}
            </div>

            {/* Bottom label below modal thumbnails */}
            <div className='mt-10'>
                <Text className='text-primary' style={{ border: "1px solid ", padding: "6px", borderRadius: "12px" }}>All Images {images.length}</Text>
            </div>
        </Modal>
    )

    return (
        <Row>
            {loading ?
                <div className="flex justify-center min-w-full min-h-[50vh] items-center">
                     <Spin spinning={loading} size={"large"} tip="Loading..." />
                </div> :
                (
                    <>
                        {images.length > 0 ? (
                            <Col span={24} style={{ top: 0, overflow: 'hidden' }}>
                                {/* Main Carousel */}
                                {imageComponet}

                                {/* modal Carousel */}
                                {modalComponent}
                            </Col>
                        ) : (
                            <Col span={24} style={{
                                border: '1px solid #ccc', padding: 15, backgroundColor: '#f5f5f5',
                                borderRadius: 8, textAlign: 'center', overflow: 'hidden', display: "flex", justifyContent: "center", alignItems: "center"
                            }} >
                                <h1 className='text-2xl'>No Images Available</h1>
                            </Col>
                        )}
                    </>
                )
            }
        </Row>
    );
};
